import React, { useEffect, useState, useRef } from "react";
import { useFetcher, useLocation, useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { LoadingIcon } from "../../../themes/userq/Loader/loadingIcon";
import { Button } from "../Button/Button";
import { CheckBox } from "../CheckBox/CheckBox";
import { Icon } from "../Icon/Icon";
import { Text } from "../Text/Text";
import { RecruitmentSlider } from "../RecruitmentSlider/RecruitmentSlider";
import { IncDecCounter } from "../IncDecCounter/IncDecCounter";
import { saregions } from "../../../../data/saregions";
import { emirates } from "../../../../data/emirates";
import { ReactSession } from "../../../../lib/secure_reactsession";
import { getCreditSummaryService } from "../../../../services/credits";
import { getTestData, submitRecruitmentRequestService } from "../../../../services/test";
import { roundNumber, showError, showToast } from "../../../../lib/helpers";
import Skeleton from "react-loading-skeleton";
import { getTestTargetGroupService } from "../../../../services/target_group";
import toast from "react-hot-toast";
import { ToastMessage } from "../ToastMessage/ToastMessage";
import { settings } from "../../../../data/settings";


export default function RecruitParticipantModal({
    openModal,
    title,
    confirm_btn_title,
    close,
    confirm,
    btnLoading,
    cssClass,
    confirm_btn_disabled,
    confirm_btn_loading,
    test_id
}) {
    const location = useLocation();

    const closeModal = () => {
        close();
    };
    const wrapperRef = useRef(null);

    const navigate = useNavigate();

    function useOutsideAlerter(ref) {
        useEffect(() => {
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    if (event.target.nodeName == "DIV") {
                        closeModal();
                    }
                }
            }
            // Bind the event listener
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                // Unbind the event listener on clean up
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    }

    useOutsideAlerter(wrapperRef);

    const [expand, setExpand] = useState(false);
    const [participantSelected, setParticipantSelected] = useState(1);
    const [participantPrice, setParticipantPrice] = useState(0);
    const [creditRequired, setCreditRequired] = useState(0);
    const [walletBalance, setWalletBalance] = useState(0);
    const [insufficientBalance, setInsufficientBalance] = useState(false);
    const [isLoading, setLoading] = useState(false);

    const [creditsLoading, setCreditsLoading] = useState(false);

    const [test, setTest] = useState(null);
    const [noDemographics, setNoDemographics] = useState(false);

    const [targetGroup, setTargetGroup] = useState(null);

    const [testersCount, setTestersCount] = useState(0);

    const [recruitmentRequestLoading, setRecruitmentRequestLoading] = useState(false);

    
    useEffect(() => {
        
        if (creditRequired > walletBalance) {
            setInsufficientBalance(true);
        } else {
            setInsufficientBalance(false);
        }
    }, [creditRequired, walletBalance]);

    useEffect(() => {
        
        setCreditRequired(roundNumber(participantSelected * participantPrice,2));
        
    }, [participantSelected, participantPrice]);

    useEffect(()=>{

        if(openModal){
           
            setParticipantSelected(1);

            getTestApi();
        }
    },[openModal]);

    const checkBtnState = ()=>{

        if(getEstimatedPanelColor()=="danger"){
            return false;
        }
        else if(insufficientBalance){
            return false;
        }
        return true;
    }

    useEffect(()=>{

        if(openModal && test){
            fetchCreditsSummary(false);
        }
    },[test]);

    const fetchCreditsSummary = (refresh=false) => {
    
        if(test){
            let token = ReactSession.get("token");

            setCreditsLoading(true);


            getCreditSummaryService({workspace_id: test.workspace_id},token).then((response) => {
                setCreditsLoading(false);
                if (response.success) {
                    ReactSession.set("credits", response.summary.credits_balance);
                    setWalletBalance(response.summary.credits_balance);
                }
            });
        }
        
    };
    const getTestApi = () => {
        let token = ReactSession.get("token");

        setLoading(true);

        let guest_result_token = '';
        if(location.pathname.substr(1, 1) === 'v'){

            guest_result_token = ReactSession.get("guest_result_token");
        }
        let admin_result_token = '';
        if(location.pathname.substr(1, 1) === 'a'){

            admin_result_token = ReactSession.get("admin_result_token");
        }

        getTestData({ test_id: test_id,guest_result_token:guest_result_token,admin_result_token:admin_result_token }, token).then((response) => {
            setLoading(false);

            if (response.success) {

                if (response.test.target_group) {
                    setTargetGroup(response.test.target_group.project_target_group);

                    var target_group = response.test.target_group.project_target_group;

                    var no_demographics = true;

                    if(target_group){
                        if(target_group.min_age && target_group.min_age!=18){
                            no_demographics = false;
                        } else if(target_group.max_age && target_group.max_age!=90){
                            no_demographics = false;
                        } else if(target_group.gender && target_group.gender!="Any"){
                            no_demographics = false;
                        }else if(target_group.countries){
                            no_demographics = false;
                        } else if(target_group.nationalities){
                            no_demographics = false;
                        } else if(target_group.education){
                            no_demographics = false;
                        } else if(target_group.hours_spend_online){
                            no_demographics = false;
                        } else if(target_group.apps){
                            no_demographics = false;
                        } else if(target_group.devices){
                            no_demographics = false;
                        } else if(target_group.devices){
                            no_demographics = false;
                        } else if(target_group.employment){
                            no_demographics = false;
                        } else if(target_group.industry){
                            no_demographics = false;
                        } else if(target_group.department){
                            no_demographics = false;
                        }else if(target_group.household_members_condition){
                            no_demographics = false;
                        }else if(target_group.income_slab){
                            no_demographics = false;
                        }
                    }
                    setNoDemographics(no_demographics);
                }
                setTest(response.test);

                setParticipantPrice(response.test.researcher_fee);

                getTestTargetGroupApi();

            } else {

                setLoading(false);


                showError(response.message);
            }
        });
    };
    const getTestTargetGroupApi = () => {
        let token = ReactSession.get("token");

        setLoading(true);

        

        getTestTargetGroupService({ test_id: test_id }, token).then(
            (response) => {
                if (response.success) {
                    
                    setTestersCount(response.testers_count);

                } else {
                    
                    toast(
                        <ToastMessage
                            type={"error"}
                            message={response}
                            closable={true}
                            onClose={() => {
                                toast.dismiss();
                            }}
                        />,
                        {
                            className: "errortoast",
                            position: "bottom-center",
                            duration: settings.toast_duration,
                        }
                    );
                    //toast.error(response.setErrorMessage)
                }
                setLoading(false);
            }
        );
    };
    const submitRecruitmentRequest = ()=>{

        if(!(checkBtnState() && !recruitmentRequestLoading)){
            return false;
        }
        let token = ReactSession.get("token");

        setRecruitmentRequestLoading(true);

        

        submitRecruitmentRequestService({ test_id: test_id, participants : participantSelected }, token).then(
            (response) => {

                
                if (response.success) {
                    
                    //showToast(response.message,"success");

                    confirm(participantSelected);

                } else {
                    
                    if(response.error_type){
                    
                        if(response.error_type=="initial_recruitment"){
    
                            showToast(
                                <>
                                    You’ve already submitted a recruitment request for this test. Please wait until the current request is completed before submitting a new one. For additional support, 
                                    <a
                                        className="disabled-support-link"
                                        href={
                                            process.env.REACT_APP_URL +
                                            "r/support/contact"
                                        }
                                        target="_blank"
                                    >
                                        get in touch with us
                                    </a>.
                                </>
                                ,(response.success ? "success" : "error"));
    
                        } else if(response.error_type=="report_and_recruit"){
    
                            showToast(
                                <>
                                    You’ve already submitted a Report and re-recruit request for this test. Once your request has been reviewed and approved, you’ll be able to submit another recruitment request if required.
                                </>
                                ,(response.success ? "success" : "error"));
    
                        } else if(response.error_type=="recruit_again"){
    
                            showToast(
                                <>
                                    You’ve already submitted a recruitment request for this test. Please wait until the current request is completed before submitting a new one. For additional support, 
                                    <a
                                        className="disabled-support-link"
                                        href={
                                            process.env.REACT_APP_URL +
                                            "r/support/contact"
                                        }
                                        target="_blank"
                                    >
                                        get in touch with us
                                    </a>.
                                </>
                                ,(response.success ? "success" : "error"));
    
                        } 
                    } else {
                        showToast(response.message,(response.success ? "success" : "error"));
                    }
                }
                setRecruitmentRequestLoading(false);
            }
        ).catch(()=>{
            setRecruitmentRequestLoading(false);
        });
    }
    const getEstimatedPanelColor = () => {
        var multiplication_factor = 1;

        
        if (
            (testersCount + test.target_group.participants_selected) >=
            participantSelected * (100 / 10) * multiplication_factor
        ) {
            //setStepperError(false);

            return "green";
        } else if (
            (testersCount + test.target_group.participants_selected >=
                participantSelected) *
                    (100 / 15) *
                    multiplication_factor &&
            testersCount + test.target_group.participants_selected <
                participantSelected *
                    (100 / 10) *
                    multiplication_factor
        ) {
            // setStepperError(false);
            return "yellow";
        } else if (
            (testersCount + test.target_group.participants_selected) >=
                participantSelected *
                    (100 / 20) *
                    multiplication_factor &&
            (testersCount + test.target_group.participants_selected) <
                participantSelected *
                    (100 / 15) *
                    multiplication_factor
        ) {
            // setStepperError(false);
            return "red";
        } else {
            return "danger";
        }
    };
    const renderUAE = () => {
        var regions = [];

        test.target_group.countries.split(",").forEach(function (item) {
            emirates.forEach(function (emirate) {
                if (emirate.value == item) {
                    regions.push(item);
                }
            });
        });
        if (regions.length > 0) {
            return (
                <div className="residents-summary-next-line">
                    UAE residents from: {regions.join(", ")}
                </div>
            );
        }
        return <></>;
    };
    const renderKSA = () => {
        var regions = [];

        test.target_group.countries.split(",").forEach(function (item) {
            saregions.forEach(function (emirate) {
                if (emirate.value == item) {
                    regions.push(item);
                }
            });
        });
        if (regions.length > 0) {
            return (
                <div className="residents-summary-next-line">
                    KSA residents from: {regions.join(", ")}
                </div>
            );
        }
        return <></>;
    };
    const renderOtherCountries = () => {
        var regions = [];

        test.target_group.countries.split(",").forEach(function (item) {
            var exist = false;

            emirates.forEach(function (emirate) {
                if (emirate.value == item) {
                    exist = true;
                }
            });

            saregions.forEach(function (emirate) {
                if (emirate.value == item) {
                    exist = true;
                }
            });

            if (!exist) {
                regions.push(item);
            }
        });
        if (regions.length > 0) {
            return (
                <div className="residents-summary-next-line">
                    Residents from: {regions.join(", ")}
                </div>
            );
        }
        return <></>;
    };

    return (
        <Modal
            show={openModal}
            centered
            className={`fade custom-modal-wrap  recruit-participants-modal ${cssClass}`}
        >
            <Modal.Body className="" ref={wrapperRef}>
                {isLoading ? (
                    <div className="modal-loader text-center">
                        <LoadingIcon />
                    </div>
                ) : (
                    <div className="modal-inner-text">
                        <div className="modal-header-top mb-20">
                            <Text type={"h3"}>{title}</Text>

                            <button
                                type="button"
                                className="close"
                                onClick={() => {
                                    closeModal();
                                }}
                                aria-label="Close"
                            >
                                <span aria-hidden="true">
                                    <Icon
                                        value="Close"
                                        size="medium"
                                        hover={true}
                                    />
                                </span>
                            </button>
                        </div>
                        {test &&
                        <>
                        <div className="row">
                            <div className="col-lg-8">
                                <div className="participants-selection-holder card-sorting-test-wrap p-24 summary-box">
                                    <Text
                                        type={"subtitle-2"}
                                        fontWeight={"medium-font"}
                                    >
                                        How many participants do you want to
                                        recruit?
                                    </Text>
                                    <div className="mt-32">
                                        <div className="mb-32 recruitment-slider-holder">
                                            <RecruitmentSlider
                                                value={participantSelected}
                                                onChange={(value) => {
                                                    setParticipantSelected(
                                                        value
                                                    );
                                                }}
                                                range={[1, 10, 25, 50, 100, 200, 500, 1000]}
                                            />
                                        </div>
                                        <div className="estimate-count-area inc-dec-holder">
                                            <IncDecCounter
                                                readOnly={false}
                                                value={participantSelected}
                                                min={1}
                                                max={1000}
                                                onChange={(value) => {
                                                    setParticipantSelected(
                                                        value
                                                    );
                                                }}
                                            />
                                        </div>
                                    </div>
                                    {getEstimatedPanelColor()=="danger" &&
                                    <div className="mt-32">
                                        {" "}
                                        <ToastMessage
                                            type={"error"}
                                            message={
                                                <span className={"w-100"}>
                                                    Uh oh! Try again by reducing
                                                    the number of participants
                                                    . For additional
                                                    support,
                                                    <a
                                                        href={
                                                            "mailto:support@userq.com"
                                                        }
                                                        className={
                                                            "font-weight-600"
                                                        }
                                                        style={{
                                                            fontSize: "16px",
                                                        }}
                                                    >
                                                        get in touch with us.
                                                    </a>
                                                </span>
                                            }
                                            closable={false}
                                        />
                                    </div>
                                    }
                                </div>
                            </div>
                            <div className="col-lg-4 pl-lg-0 mt-lg-0 mt-16">
                                <div className="participants-selection-holder card-sorting-test-wrap p-24 summary-box">
                                    <Text
                                        type={"body-text-2"}
                                        fontWeight={"semi-bold-font"}
                                    >
                                        Order summary
                                    </Text>
                                    <div className="mt-24">
                                        <Text
                                            type={"body-text-3"}
                                            fontWeight={"medium-font"}
                                        >
                                            Price per participants:{" "}
                                            {participantPrice} credits
                                        </Text>
                                        <Text
                                            type={"body-text-3"}
                                            fontWeight={"medium-font"}
                                            cssClasses={"mt-8"}
                                        >
                                            Total credits required:{" "}
                                            {creditRequired} credits
                                        </Text>
                                        <Text
                                            type={"body-text-3"}
                                            fontWeight={"medium-font"}
                                            cssClasses={"mt-8"}
                                        >
                                            Wallet balance:{" "}
                                            {creditsLoading 
                                            ?
                                            <Skeleton
                                                width={110}
                                                height={20}
                                                style={{

                                                    display:"inline-block",
                                                    marginRight: "0px",
                                                    marginLeft: "20px",
                                                }}
                                            />
                                            :
                                            <>
                                                <span
                                                    className={`${
                                                        insufficientBalance
                                                            ? "red-text"
                                                            : ""
                                                    }`}
                                                >
                                                    {walletBalance} credits
                                                </span>
                                                
                                                <Icon
                                                    value={"refresh"}
                                                    size={"medium"}
                                                    cssClasses={"ml-8 cursor-pointer gray-900-svg"}
                                                    onClick={()=>{fetchCreditsSummary(true)}}
                                                    
                                                />
                                                </>
                                            }
                                            
                                        </Text>
                                        {insufficientBalance ? (
                                            <div className="d-flex align-items-center mt-8">
                                                <Icon
                                                    colorClass={
                                                        "danger-200-svg"
                                                    }
                                                    value={"error"}
                                                    size={"small"}
                                                    cssClasses={"mr-4x"}
                                                />{" "}
                                                <Text
                                                    cssClasses={"red-text"}
                                                    type={"caption"}
                                                >
                                                    Insufficient balance
                                                </Text>{" "}
                                                <Button
                                                    type={"primary"}
                                                    size={"small"}
                                                    label={"Buy Credits"}
                                                    cssclass={"ml-8"}
                                                />
                                            </div>
                                        ) : (
                                            <div className="d-flex align-items-center mt-8">
                                                <Icon
                                                    colorClass={
                                                        "success-200-svg"
                                                    }
                                                    value={"success"}
                                                    size={"small"}
                                                    cssClasses={"mr-4x"}
                                                />{" "}
                                                <Text
                                                    cssClasses={"green-text"}
                                                    type={"caption"}
                                                >
                                                    Balance available
                                                </Text>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="mt-16">
                            <div className="pay-on-fly-coupon-code-wrap">
                                <div className="promo-code-inner">
                                    <div
                                        className="pay-on-fly-promo-code-hdr demographics-box"
                                        onClick={() => {
                                            setExpand(!expand);
                                        }}
                                    >
                                        <Text
                                            type={"body-text-2"}
                                            fontWeight={"medium-font"}
                                        >
                                            Demographics
                                        </Text>
                                        <div className="pay-promo-close">
                                            {!expand && (
                                                <span>
                                                    <img
                                                        src={
                                                            process.env
                                                                .REACT_APP_URL +
                                                            "img/chevron.svg"
                                                        }
                                                        alt="icon"
                                                    />
                                                </span>
                                            )}
                                            {expand && (
                                                <span>
                                                    <img
                                                        src={
                                                            process.env
                                                                .REACT_APP_URL +
                                                            "img/chevron-up.svg"
                                                        }
                                                        alt="icon"
                                                    />
                                                </span>
                                            )}
                                        </div>
                                    </div>

                                    {expand && test && (
                                        <div className="promocode-inner-form-wrap p-24 pt-0 border-top-0">
                                            {test.target_group && test.target_group.is_demographics==1 &&
                                            <>
                                                {!noDemographics &&
                                                <div className="test-summary-participants test-summary-screening-questions mb-32">
                                                    
                                                    {targetGroup.min_age &&
                                                    <div className="row summary-modal-data-repeat">
                                                        <div className="col-md-6 summary-left">
                                                            <div className="summary-left-sec-wrap">
                                                                <Text type={"body-text-2"} fontWeight={'medium-font'} children={"Age Group"} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 summary-right">
                                                            <div className="summary-right-sec-wrap">
                                                                <Text type={"body-text-2"} fontWeight={'semi-bold-font'}>   {targetGroup.min_age} - {targetGroup.max_age} </Text>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    }
                                                    {targetGroup.gender &&
                                                    <div className="row summary-modal-data-repeat">
                                                        <div className="col-md-6 summary-left">
                                                            <div className="summary-left-sec-wrap">
                                                                <Text type={"body-text-2"} fontWeight={'medium-font'} children={"Gender"} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 summary-right">
                                                            <div className="summary-right-sec-wrap">
                                                                <Text type={"body-text-2"} fontWeight={'semi-bold-font'}>   {targetGroup.gender} </Text>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    }
                                                    {targetGroup.countries &&
                                                    <div className="row summary-modal-data-repeat">
                                                        <div className="col-md-6 summary-left">
                                                            <div className="summary-left-sec-wrap">
                                                                <Text type={"body-text-2"} fontWeight={'medium-font'} children={"Residency"} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 summary-right">
                                                            <div className="summary-right-sec-wrap">
                                                                <Text type={"body-text-2"} fontWeight={'semi-bold-font'}>
                                                                    {renderUAE()}
                                                                </Text>
                                                                <Text type={"body-text-2"} fontWeight={'semi-bold-font'}>
                                                                    {renderKSA()}
                                                                </Text>
                                                                <Text type={"body-text-2"} fontWeight={'semi-bold-font'}>
                                                                    {renderOtherCountries()}
                                                                </Text>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    }
                                                    {targetGroup.nationalities &&
                                                    <div className="row summary-modal-data-repeat">
                                                        <div className="col-md-6 summary-left">
                                                            <div className="summary-left-sec-wrap">
                                                                <Text type={"body-text-2"} fontWeight={'medium-font'} children={"Nationalities"} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 summary-right">
                                                            <div className="summary-right-sec-wrap">
                                                                <Text type={"body-text-2"} fontWeight={'semi-bold-font'}>   {targetGroup.nationalities.split(",").join(", ")} </Text>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    }
                                                    {targetGroup.education &&
                                                    <div className="row summary-modal-data-repeat">
                                                        <div className="col-md-6 summary-left">
                                                            <div className="summary-left-sec-wrap">
                                                                <Text type={"body-text-2"} fontWeight={'medium-font'} children={"Minimum level of education"} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 summary-right">
                                                            <div className="summary-right-sec-wrap">
                                                                <Text type={"body-text-2"} fontWeight={'semi-bold-font'}>   {targetGroup.education} </Text>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    }
                                                    {targetGroup.hours_spend_online &&
                                                    <div className="row summary-modal-data-repeat">
                                                        <div className="col-md-6 summary-left">
                                                            <div className="summary-left-sec-wrap">
                                                                <Text type={"body-text-2"} fontWeight={'medium-font'} children={"Average time spend online per day"} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 summary-right">
                                                            <div className="summary-right-sec-wrap">
                                                                <Text type={"body-text-2"} fontWeight={'semi-bold-font'}>   {targetGroup.hours_spend_online} </Text>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    }
                                                    {targetGroup.apps &&
                                                    <div className="row summary-modal-data-repeat">
                                                        <div className="col-md-6 summary-left">
                                                            <div className="summary-left-sec-wrap">
                                                                <Text type={"body-text-2"} fontWeight={'medium-font'} children={"App used"} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 summary-right">
                                                            <div className="summary-right-sec-wrap">
                                                                <Text type={"body-text-2"} fontWeight={'semi-bold-font'}>   {targetGroup.apps.split(",").join(", ")} </Text>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    }
                                                    {targetGroup.devices &&
                                                    <div className="row summary-modal-data-repeat">
                                                        <div className="col-md-6 summary-left">
                                                            <div className="summary-left-sec-wrap">
                                                                <Text type={"body-text-2"} fontWeight={'medium-font'} children={"Favorite device"} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 summary-right">
                                                            <div className="summary-right-sec-wrap">
                                                                <Text type={"body-text-2"} fontWeight={'semi-bold-font'}>   {targetGroup.devices.split(",").join(", ")} </Text>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    }
                                                    {targetGroup.employment &&
                                                    <div className="row summary-modal-data-repeat">
                                                        <div className="col-md-6 summary-left">
                                                            <div className="summary-left-sec-wrap">
                                                                <Text type={"body-text-2"} fontWeight={'medium-font'} children={"Employment status"} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 summary-right">
                                                            <div className="summary-right-sec-wrap">
                                                                <Text type={"body-text-2"} fontWeight={'semi-bold-font'}>   {targetGroup.employment.split(",").join(", ")} </Text>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    }
                                                    {targetGroup.industry &&
                                                    <div className="row summary-modal-data-repeat">
                                                        <div className="col-md-6 summary-left">
                                                            <div className="summary-left-sec-wrap">
                                                                <Text type={"body-text-2"} fontWeight={'medium-font'} children={"Industry"} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 summary-right">
                                                            <div className="summary-right-sec-wrap">
                                                                <Text type={"body-text-2"} fontWeight={'semi-bold-font'}>   {targetGroup.industry.split("|").join(", ")} </Text>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    }
                                                    {targetGroup.department &&
                                                    <div className="row summary-modal-data-repeat">
                                                        <div className="col-md-6 summary-left">
                                                            <div className="summary-left-sec-wrap">
                                                                <Text type={"body-text-2"} fontWeight={'medium-font'} children={"Department"} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 summary-right">
                                                            <div className="summary-right-sec-wrap">
                                                                <Text type={"body-text-2"} fontWeight={'semi-bold-font'}>   {targetGroup.department.split(",").join(", ")} </Text>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    }
                                                    {targetGroup.household_members_condition &&
                                                    <div className="row summary-modal-data-repeat">
                                                        <div className="col-md-6 summary-left">
                                                            <div className="summary-left-sec-wrap">
                                                                <Text type={"body-text-2"} fontWeight={'medium-font'} children={"Members in household"} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 summary-right">
                                                            <div className="summary-right-sec-wrap">
                                                                <Text type={"body-text-2"} fontWeight={'semi-bold-font'}>  {targetGroup.household_members_condition == "All" ? "Exact" : targetGroup.household_members_condition} {targetGroup.people} </Text>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    }
                                                    {targetGroup.income_slab &&
                                                    <div className="row summary-modal-data-repeat">
                                                        <div className="col-md-6 summary-left">
                                                            <div className="summary-left-sec-wrap">
                                                                <Text type={"body-text-2"} fontWeight={'medium-font'} children={"Household income $ per month"} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 summary-right">
                                                            <div className="summary-right-sec-wrap">
                                                                <Text type={"body-text-2"} fontWeight={'semi-bold-font'}>  {targetGroup.income_slab.split("|").join(", ")} </Text>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    }
                                                </div>
                                                }
                                                
                                            </>
                                            }
                                            {test.target_group && test.target_group.is_demographics==0  &&
                                                <div className="test-summary-participants test-summary-screening-questions mb-40">
                                                    
                                                    <div className="no-demographics-selected mt-16">
                                                        <Text type={"body-text-2"} fontWeight={"normal-font"}>No reruitment filters selected</Text>
                                                    </div>
                                                </div>
                                                }
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="d-flex justify-content-center mt-32">
                            <Button
                                type="primary"
                                microLoading={
                                    recruitmentRequestLoading
                                        ? recruitmentRequestLoading
                                        : false
                                }
                                size="large"
                                label={
                                    confirm_btn_title ? confirm_btn_title : "OK"
                                }
                                onClick={() => {
                                    submitRecruitmentRequest();
                                }}
                                state={checkBtnState()?"active":"disabled"}
                            />
                        </div>
                        </>
                        }
                    </div>
                )}
            </Modal.Body>
        </Modal>
    );
}
